import * as d3 from 'd3'

export default {

  methods: {

    set_LocalValues(){

      this.chartData = JSON.parse(JSON.stringify(this.DataItems))
      this.cutoff = JSON.parse(JSON.stringify(this.Queries.SQL1[0].CUTOFF))
      
      let json = JSON.parse(JSON.stringify(this.JQueries))

      //##### JSON #####
      this.title       = json.title
      this.timeline    = json.timeline
      this.primary     = json.primary
      this.secondary   = json.secondary
      this.chart       = json.chart
      this.legends     = json.legends
      this.summary     = json.summary
      this.sundries    = json.sundries

      // Additional Keys
      this.timeline.axis = null
      this.timeline.band = null

      this.primary.axis = null
      this.primary.max = null
      this.secondary.axis = null
      this.secondary.max = null

      // Calculate the Height of Canvas
      this.Canvas.CanvasWidth = this.chart.width + this.chart.x * 2
      this.Canvas.CanvasHeight = this.chart.height + this.chart.y + 40


      // Setting Timeline ----------------------------
      this.timeline.axis = d3.scaleBand()
      .domain(this.chartData.map(d => d.CDATE ))
      .range([0, this.chart.width])
      this.timeline.band = this.timeline.axis.bandwidth()

      this.gmx_BandScaleValues_Week(this.chartData)

      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      this.timeline.month.forEach(d=> {
        if(this.timeline.monthFormat == 'number') d.name = months.findIndex(f=> d.name == f) + 1
        if(this.timeline.monthFormat == 'char1') d.name = d.name.substring(0, 1)
      })

      // Set Coordinates for Bar X -------------------
      this.chartData.forEach((d,i)=> {
        d.bxs = this.gmx_BarCoordinates(d.mx, [...this.chart.styles.filter(f=> f.type=='BAR').map(m => m.size)], this.chart.barGap)
        // console.log([...this.chart.styles.filter(f=> f.type=='BAR').map(m => m.size)])
        // console.log(d.bxs)
      })
      

      //
      //
      //
      //
      //


      // Setting Primary --------------------------------------------------------
      let maxArray = []
      if(this.chart.styles.filter(f=> f.type == 'BAR').length == 0) {
        this.primary.visible = 'N'
        this.secondary.position = 'left'
      } else { this.primary.visible = 'Y' }

      if(this.primary.visible == 'Y') {
        this.chart.styles.filter(f=> f.type == 'BAR').forEach((s,i)=> {
          maxArray.push(d3.max(this.chartData, c => c[s.code]))
        })

        this.primary.max = d3.max(maxArray)
        // console.log(this.primary.max)
        if(this.primary.max == 0) this.primary.max = 25
        if(this.primary.max < 2.5) this.primary.max = 2.5
        if(this.primary.max > 2.5) this.primary.max = this.gmx_maxBound5(this.primary.max)

        this.primary.axis = d3.scaleLinear()
        .domain([0, this.primary.max])
        .range([0, this.chart.height])
      }
      this.primary.titleX = -this.primary.padding
     


      // Setting secondary ------------------------------------------------------

      let val = null
      let unit = this.secondary.unit.substr(this.secondary.unit.length-1, 1)
      if(unit == '%') {
        val = this.secondary.unit.substr(0,this.secondary.unit.length-1)
        this.secondary.unit = '%'
      }

      if(unit == '%' && val) {
        this.secondary.max = val
      } else {
        maxArray = []
        this.chart.styles.filter(f=> f.type == 'LINE').forEach((s,i)=> {
          maxArray.push(d3.max(this.chartData, c => c[s.code]))
        })
  
        this.secondary.max = d3.max(maxArray)
        if(this.secondary.max == 0) this.secondary.max = 25; else this.secondary.max = this.gmx_maxBound5(this.secondary.max)
      }
     
      this.secondary.axis = d3.scaleLinear()
      .domain([0, this.secondary.max])
      .range([this.chart.height, 0])

      this.secondary.titleX = this.chart.width + this.secondary.padding
    },


  }
}